import type { ResearchModeState } from '../types';

interface ResearchEarProps {
  state: ResearchModeState;
  customerEmail: string | null;
  onToggle: () => void;
}

// Microscope icon for research mode
const MicroscopeIcon = () => (
  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

export function ResearchEar({
  state,
  customerEmail: _customerEmail,
  onToggle,
}: ResearchEarProps) {
  const isActive = state.enabled && state.verified;
  const isPulsing = state.verificationPending;

  return (
    <button
      onClick={onToggle}
      className={`
        absolute right-0 bottom-[14.5rem] z-40
        w-6 h-8 rounded-l-md shadow-md
        flex items-center justify-center
        text-sm cursor-pointer
        transition-all duration-200
        hover:w-7 hover:shadow-lg
        ${isActive
          ? 'bg-blue-500 text-white'
          : 'bg-white border border-r-0 border-gray-200 text-gray-600 hover:text-gray-800'
        }
        ${isPulsing ? 'animate-pulse' : ''}
      `}
      aria-label="Research mode"
      title={isActive ? 'Research mode active' : 'Enable research mode'}
    >
      <MicroscopeIcon />
    </button>
  );
}
